import styled from 'styled-components'

export default styled.li`
  color: ${props => props.theme.header.search.sections.color};
  cursor: pointer;
  display: inline-block;
  font-size: 12px;
  line-height: 13px;
  &.active span, &:hover span {
    border-bottom: 3px solid ${props => props.theme.header.search.sections.activeColor};
    color: ${props => props.theme.header.search.sections.activeColor};
  }
  &:not(:last-child) {
    border-right: 1px solid #d7d7d7;
    margin-right: 0.8vw;
    padding-right: 0.8vw;
  }
`
